import $ from 'jquery';

$(document).ready(function() {
	$(document).on('click', '.js-museums-info', function() {
		$('.b-museums__info').not($(this).parents('.js-info-item').find('.b-museums__info')).removeClass('show');
		$(this).parents('.js-info-item').find('.b-museums__info').toggleClass('show');
	});
	$(document).on('click', 'body', function(e) {
		if (!((e.target).closest('.b-museums__info')) && !((e.target).closest('.js-museums-info'))) {
			$('.b-museums__info').removeClass('show');
		}
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/main/museums-info.js